import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { encryptText } from "../helper/encryptHelper";

export const resultlotteryReducer = createSlice({
  name: "resultlottery",
  initialState: {
    resultLottery: null,
    resultLotteryYeekee: null,
  },
  reducers: {
    setResultLottery: (state, { payload }) => {
      state.resultLottery = payload;
    },
    setResultLotteryYeekee: (state, { payload }) => {
      state.resultLotteryYeekee = payload;
    },
  },
});

export const { setResultLottery, setResultLotteryYeekee } =
  resultlotteryReducer.actions;
export default resultlotteryReducer.reducer;

const header2 = {
  headers: {
    "Content-Type": "application/text/plain",
    Authorization: `Bearer ${localStorage.getItem("Token")}`,
  },
};

const getResultLottery = () => async (dispatch) => {
  const body = {
    member: "625fae71714af20bc491c73f",
  };
  const cryptoData = encryptText(
    JSON.stringify(body),
   localStorage.getItem("Key")
  );

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_PROVIDER}/api/lotteryRound/cusSite/getNearestShowResultRounds`,
      cryptoData,
      header2
    );
    if (res.data.code == "999999") {
      dispatch(setResultLottery(res.data.data));
    }
  } catch (err) {
    console.error(err);
  }
};

const getResultLotteryFromDate = (date) => async (dispatch) => {
  const body = {
    member: "625fae71714af20bc491c73f",
    roundDate: new Date(new Date(date).setHours(0, 0, 0, 0)),
    group: "nonyeekee",
  };
  const cryptoData = encryptText(
    JSON.stringify(body),
   localStorage.getItem("Key")
  );
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_PROVIDER}/api/lotteryRound/cusSite/getLotteryRoundsYeeKeeGroup`,
      cryptoData,
      header2
    );
    if (res.data.code == "999999") {
      dispatch(setResultLottery(res.data.data));
    }
  } catch (err) {
    console.error(err);
  }
};

const getResultLotteryYeekee = (date) => async (dispatch) => {
  const body = {
    member: "625fae71714af20bc491c73f",
    roundDate: new Date(new Date(date).setHours(0, 0, 0, 0)),
    group: "yeekee",
  };
  const cryptoData = encryptText(
    JSON.stringify(body),
   localStorage.getItem("Key")
  );

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_PROVIDER}/api/lotteryRound/cusSite/getLotteryRoundsYeeKeeGroup`,
      cryptoData,
      header2
    );
    if (res.data.code == "999999") {
      dispatch(setResultLotteryYeekee(res.data.data));
    }
  } catch (err) {
    console.error(err);
  }
};

export { getResultLottery, getResultLotteryFromDate, getResultLotteryYeekee };
